import { ResolveFn, Routes } from '@angular/router';
import { inject } from '@angular/core';
import { HxCategoryService, ProductCategoryModel } from 'hx-services';
import { ProductCategoryListComponent } from '@adm-web-app/modules/product-categories/list/product-category-list.component';
import { ProductCategoryEditComponent } from '@adm-web-app/modules/product-categories/edit/product-category-edit.component';

const productCategoryResolveFn: ResolveFn<ProductCategoryModel> = route => inject(HxCategoryService).getCategory(Number(route.paramMap.get('id')));

export const productCategoriesRoutes: Routes = [
  {
    path: '', component: ProductCategoryListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
  {
    path: 'new', component: ProductCategoryEditComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':id/edit', component: ProductCategoryEditComponent,
    resolve: {
      model: productCategoryResolveFn,
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
];
